import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export interface RelatedLink {
  label: string;
  href: string;
  description: string;
}
interface RelatedLinksProps {
  title?: string;
  links: RelatedLink[];
}
export function RelatedLinks({
  title = 'Related',
  links
}: RelatedLinksProps) {
  return <nav aria-label={title} className="w-full bg-warm" data-id="element-560" data-mp="2wjirxdjcmv9m">
      <div className="mx-auto max-w-shell px-5 py-12 lg:px-10 lg:py-14" data-id="element-561" data-mp="2rlh8uslxavy5">
        <h2 className="font-mono text-[10px] tracking-label text-copper" data-id="element-562" data-mp="2mu8x3px4eyht">
          {title.toUpperCase()}
        </h2>
        <ul className="mt-5 grid gap-px border border-rule bg-rule sm:grid-cols-2 lg:grid-cols-4" data-id="element-563" data-mp="2humj3e9gxe7y">
          {links.map(link => <li key={link.href} className="flex bg-white" data-id="element-564" data-mp="2cxdwn1haeo0w">
              <Link to={link.href} className="group flex w-full flex-col p-5 transition-colors duration-150 ease-precise hover:bg-warm" data-id="element-565" data-mp="28u7t41lk7ay4">
                <span className="flex items-center justify-between gap-3 text-[15px] font-semibold text-navy group-hover:text-copper" data-id="element-566" data-mp="16cry8ohxn5l6">
                  {link.label}
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-copper" data-id="element-567" data-mp="1b4t3vrklhy28" />
                </span>
                <span className="mt-1.5 text-[13.5px] leading-relaxed text-graphite/75" data-id="element-568" data-mp="11eqavrdh4k3w">
                  {link.description}
                </span>
              </Link>
            </li>)}
        </ul>
      </div>
    </nav>;
}